module.exports = __webpack_public_path__ + "img/p_icon03.572539af.svg";